import type { MacroMeasurement, MacroRunCommand, MacroRunReply } from '@playcastdotio/Messaging';

const MAX_MEASUREMENT_ROWS = 64;
const MAX_DIAGNOSTIC_BYTES = 16 * 1024;

/** Copies only the fields of the single v2 measurement row; anything else on the reply is dropped. */
function allowlistMeasurement(item: MacroMeasurement): Record<string, unknown> {
  return {
    nodeId: item.nodeId.slice(0, 128), candidateId: item.candidateId.slice(0, 128),
    frameSequence: item.frameSequence, decision: item.decision,
    differenceNumerator: item.differenceNumerator, differenceDenominator: item.differenceDenominator,
    runnerUpNumerator: item.runnerUpNumerator, runnerUpDenominator: item.runnerUpDenominator,
    captureToDecisionMs: item.captureToDecisionMs,
  };
}

/** Constructs diagnostics without copying authored macro content. */
export class NativeMacroTelemetry {
  public static diagnostic(command: MacroRunCommand, reply: MacroRunReply): Record<string, unknown> {
    const result: Record<string, unknown> = {
      telemetrySchema: 'macro-observability-v2', subsystem: 'macro', component: 'native-macro-bridge',
      operation: command.command, requestId: command.requestId.slice(0, 128), runId: command.runId.slice(0, 128),
      outcome: reply.outcome, inputsSent: reply.inputsSent,
    };
    if (reply.errorCode) result.errorCode = reply.errorCode.slice(0, 256);
    if (reply.preflightStage) result.preflightStage = reply.preflightStage;
    if (command.command === 'start' && command.bundle) Object.assign(result, {
      campaignId: command.bundle.campaignId.slice(0, 128), revisionPrefix: command.bundle.revision.slice(0, 12),
      trigger: command.bundle.trigger, profile: command.bundle.profile, mode: command.mode,
    });
    if (reply.measurements) {
      const measurements = reply.measurements.slice(0, MAX_MEASUREMENT_ROWS).map(allowlistMeasurement);
      result.measurements = measurements;
      if (reply.measurements.length > measurements.length) result.measurementsTruncated = true;
      while (new TextEncoder().encode(JSON.stringify(result)).length > MAX_DIAGNOSTIC_BYTES && measurements.length) {
        measurements.pop(); result.measurementsTruncated = true;
      }
    }
    return result;
  }
}
